// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "layout-views-OlivosFilesView-vue" + "." + "b5fba46f" + ".css";
};